import { Button, Container, Flex, Image, Link, Text } from "@chakra-ui/react";
import Head from "next/head";
import React, { useEffect, useState } from "react";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function CrearCuenta() {
    const [screenSize, getDimension] = useState({
        winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
        winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
    });

    const setDimensions = () => {
        getDimension({
            winWidth: typeof window === "undefined" ? 0 : window.innerWidth,
            winHeight: typeof window === "undefined" ? 0 : window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", setDimensions);

        return () => {
            window.removeEventListener("resize", setDimensions);
        };
    }, [screenSize]);

    const icons = [
        { imgUrl: "https://media.grupoguia.mx/assets/home-page/icons/icon-check-typ.svg" },
    ];

    return (
        <>
            <Head>
                <title>ThankYouPage Registro | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/thankyoupage-registro" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/thankyoupage-registro"
                    hrefLang="es-mx"
                />
            </Head>
            <Header />
            <Container
                maxW="100vw"
                {...(screenSize.winWidth <= 768 && { paddingInline: "0" })}
                paddingTop="8rem"
                paddingBottom="6rem"
                px={5}
            >
                <Flex
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    textAlign={{ base: "center", md: "initial" }}
                >
                    <Image src={icons[0].imgUrl} width="186" height="186" alt="icon" />
                    <Text fontSize="2xl">
                        <span style={{ fontWeight: "700" }}>Felicidades</span> has creado tu cuenta
                    </Text>
                    <Text marginTop="0.5rem" fontSize="md">
                        Te enviamos un correo electronico para verificar tu cuenta
                    </Text>
                    <Text marginTop="2rem" fontSize="md">
                        ¿No has recibido el correo electrónico?
                    </Text>
                    <Link
                        marginBottom="2rem"
                        color="#1F79B8"
                        href="/login"
                        textDecoration="underline"
                    >
                        Volver a enviar el correo electrónico de verificación
                    </Link>
                    <Button
                        style={{ width: "282px", height: "44px" }}
                        mt={2}
                        py={6}
                        px={2}
                        rounded="full"
                        color="#000"
                        size="sm"
                        right={0}
                        _active={{ bg: "brand.500" }}
                        aria-label="Comenzar requerimiento"
                        bgColor="brand.500"
                        href="/login"
                        _hover={{
                            textDecoration: "none",
                            color: "#000",
                            bg: "brand.500",
                        }}
                        external
                        asChild
                    >
                        <Link>Volver</Link>
                    </Button>
                </Flex>
            </Container>
            <Footer />
        </>
    );
}
